<template>
  <!-- See for more info on the purpose of v-bind here - https://vuejs.org/guide/components/attrs.html#attribute-inheritance-on-multiple-root-nodes-->
  <button v-bind="$attrs" class="flex h-10 items-center gap-1 rounded-3xl bg-red px-4 text-white sm:h-12" @click="onClick">
    <gv-icon name="call" class="w-6 fill-white" fill />
    <div class="hidden sm:block">{{ t('948IeswNH_16gV0iQ4-wR') }}</div>
    <div class="sm:hidden">{{ t('wqskiEAuwxVomEgKTpddC') }}</div>
  </button>
  <ui-emergency-modal :modal="emergencyModal" />
</template>

<script setup lang="ts">
import { useModal } from '@/common/composables/useModal';
import * as Symbols from '@/common/constants/symbols';
import { BREAKPOINTS } from '@/constants';
import { useBreakpoints } from '@vueuse/core';
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const emergencyModal = useModal();

const injected = {
  emergencyBottomSheet: inject(Symbols.EmergencyBottomSheet)!,
};

const onClick = () => {
  if (isBreakpointMd.value) {
    injected.emergencyBottomSheet.setOpen();
    return;
  }
  emergencyModal.setOpen();
};

const breakpoints = useBreakpoints(BREAKPOINTS);
const isBreakpointMd = breakpoints.smaller('md');
</script>
